import { SidebarGroupContent } from '../components/SidebarGroup';
import {
  SidebarMenu,
  SidebarMenuItem,
  SidebarNavigationItem,
} from '../components/SidebarMenu';
import { type SideBarConfig } from '../types/Sidebar.types';

type SidebarHubProps = {
  config: SideBarConfig;
};

export const SidebarHub = ({ config }: SidebarHubProps) => {
  return (
    <SidebarGroupContent className="mb-1.5">
      <SidebarMenu>
        {config.map((item) => (
          <SidebarMenuItem key={item.title}>
            <SidebarNavigationItem {...item} tooltip={item.title} />
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroupContent>
  );
};
